// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3f2qJ","header":"ClearentDisclaimer_header__2_h6p","inner":"ClearentDisclaimer_inner__ReG1I"};